<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer002">
<p class="CT ParaOverride-1" id="_idParaDest-1"> </p>
<p class="HT">CARDIFF, BY THE SEA</p>
<p class="BT1stPara ParaOverride-2"><span class="CharOverride-1">Four Novellas</span></p>
<p class="BT1stPara ParaOverride-3"><span class="CharOverride-1">of Suspense</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780802158017.vue?b89cefe6